import { addDaysUtc, startOfWeekUtc } from "./dateUtils";
import type { CalendarFormat } from "./dateUtils";
import type { CalendarCell } from "./types";

const DAYS = 7;

export interface CalendarWeekCells {
  /** Mo–So column labels, localized. */
  weekdayLabels: string[];
  /** The seven days of the week, Monday-first. */
  days: CalendarCell[];
}

/**
 * Builds a single Monday-first week of pure date cells around `anchor`. Selection
 * and bounds are resolved by the calendar hook, not here.
 *
 * @param anchor - Any date within the target week (read via UTC getters).
 * @param format - Locale-bound formatters for cell and column labels.
 */
export function buildCalendarWeek(anchor: Date, format: CalendarFormat): CalendarWeekCells {
  const start = startOfWeekUtc(anchor);
  const days = Array.from({ length: DAYS }, (_, day) => format.toCell(addDaysUtc(start, day)));

  return { weekdayLabels: format.weekdayLabels(start), days };
}
